import React from 'react';
import PropTypes from 'prop-types';

function PrivabWarehouseIndicator({ stroke, height }) {
  return (
    <svg
      id="Lager_1"
      data-name="Lager 1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 841.89 402.52"
      stroke={stroke}
      strokeWidth="18"
      height={height}
      fill="none"
      strokeMiterlimit={10}
    >
      <line className="cls-1" x1="3.85" y1="114.21" x2="506.3" y2="114.21" />
      <polyline
        className="cls-1"
        points="399.04 61.59 145.6 62.48 145.6 9.12 616.56 9.12 618.47 342.4 338.26 342.4"
      />
      <line className="cls-1" x1="102.15" y1="176.84" x2="461.42" y2="176.84" />
      <line className="cls-1" x1="636.14" y1="342.4" x2="665.23" y2="342.4" />
      <path
        className="cls-1"
        d="M768.61,342.4h66.21c0-114.88-5.04-65.19-14.39-96.5-1.1-3.67-2.32-7.31-3.68-10.91l-78.57-1.31"
      />
      <line className="cls-1" x1="43.93" y1="246.14" x2="294.96" y2="244.77" />
      <polyline
        className="cls-1"
        points="148.16 287.98 148.16 340.49 241.59 340.49"
      />
      <ellipse className="cls-1" cx="289.77" cy="337.4" rx="48.48" ry="51.87" />
      <ellipse className="cls-1" cx="717.39" cy="342.4" rx="48.48" ry="51.87" />
      <path
        className="cls-1"
        d="M636.14,114.21h99.15c25.83,0,48.79,17.61,57.08,43.79l24.38,76.99"
      />
      <line className="cls-1" x1="790.72" y1="285.53" x2="819.81" y2="285.53" />
    </svg>
  );
}
PrivabWarehouseIndicator.propTypes = {
  stroke: PropTypes.string,
  height: PropTypes.string,
};

PrivabWarehouseIndicator.defaultProps = {
  stroke: 'black',
  height: '23',
};
export default PrivabWarehouseIndicator;
